import siteMessage from "@insite/client-framework/SiteMessage";

const emailRegexp = new RegExp("\\w+([-+.']\\w+)*@\\w+([-.]\\w+)*\\.\\w+([-.]\\w+)*");
const phoneRegex = /^([\(\)/\-\.\+\s]*\d\s?(ext)?[\(\)/\-\.\+\s]*){10,20}$/;

export const isEmpty = (value: string) => value.trim().length <= 0;
const isValidPhoneNumber = (value: string) => phoneRegex.test(value);

export const phoneValidator = (phone: string) =>
    !isEmpty(phone) && !isValidPhoneNumber(phone) ? siteMessage("AddressInfo_Phone_Validation").toString() : "";

const emailRequiredFieldMessage = siteMessage("CreateNewAccountInfo_EmailAddress_Required") as string;
const emailFieldMessage = siteMessage("CreateNewAccountInfo_EmailAddress_ValidEmail") as string;

export const emailValidator = (email: string) => {
    const errorMessage = !email ? emailRequiredFieldMessage : emailRegexp.test(email) ? "" : emailFieldMessage;
    return errorMessage;
};
